export default __webpack_public_path__ + "static/media/orange-carousel-headline-box@2x.1bfd513c.png";